export default "__VITE_ASSET__CfUecvXA__"